(() => {
const AS_RING_SIZE_CHART = [
  { us: 4, diameter: 14.9, circumference: 46.8, uk: 'H 1/2', eu: 47 },
  { us: 4.5, diameter: 15.3, circumference: 48.0, uk: 'I 1/2', eu: 48 },
  { us: 5, diameter: 15.7, circumference: 49.3, uk: 'J 1/2', eu: 49 },
  { us: 5.5, diameter: 16.1, circumference: 50.6, uk: 'K 1/2', eu: 51 },
  { us: 6, diameter: 16.5, circumference: 51.9, uk: 'L 1/2', eu: 52 },
  { us: 6.5, diameter: 16.9, circumference: 53.1, uk: 'M 1/2', eu: 53 },
  { us: 7, diameter: 17.3, circumference: 54.4, uk: 'N 1/2', eu: 54 },
  { us: 7.5, diameter: 17.7, circumference: 55.7, uk: 'O 1/2', eu: 56 },
  { us: 8, diameter: 18.1, circumference: 57.0, uk: 'P 1/2', eu: 57 },
  { us: 8.5, diameter: 18.5, circumference: 58.3, uk: 'Q 1/2', eu: 58 },
  { us: 9, diameter: 18.9, circumference: 59.5, uk: 'R 1/2', eu: 60 },
  { us: 9.5, diameter: 19.4, circumference: 60.8, uk: 'S 1/2', eu: 61 },
  { us: 10, diameter: 19.8, circumference: 62.1, uk: 'T 1/2', eu: 62 },
  { us: 10.5, diameter: 20.2, circumference: 63.4, uk: 'U 1/2', eu: 63 },
  { us: 11, diameter: 20.6, circumference: 64.6, uk: 'V 1/2', eu: 65 },
  { us: 11.5, diameter: 21.0, circumference: 65.9, uk: 'W 1/2', eu: 66 },
  { us: 12, diameter: 21.4, circumference: 67.2, uk: 'X 1/2', eu: 67 },
];

class ASProductPersonalization extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.toggle = this.querySelector('[data-as-engraving-toggle]');
    this.fields = this.querySelector('[data-as-engraving-fields]');
    this.engravingInput = this.querySelector('[data-as-engraving-input]');
    this.count = this.querySelector('[data-as-engraving-count]');
    this.sizeDialog = this.querySelector('[data-as-size-dialog]');
    this.inclusionsDialog = this.querySelector('[data-as-inclusions-dialog]');
    this.sizeRange = this.querySelector('[data-as-size-range]');
    this.fingerRange = this.querySelector('[data-as-finger-range]');
    this.calibrationRange = this.querySelector('[data-as-calibration-range]');
    this.suggestedSize = null;
    this.screenScale = Number.parseFloat(localStorage.getItem('as-ring-screen-scale') || '1');
    if (!Number.isFinite(this.screenScale)) this.screenScale = 1;

    this.addEventListener('click', (event) => this.handleClick(event));
    this.addEventListener('input', (event) => this.handleInput(event));
    this.sizeDialog?.addEventListener('click', (event) => {
      if (event.target === this.sizeDialog) this.sizeDialog.close();
    });
    this.inclusionsDialog?.addEventListener('click', (event) => {
      if (event.target === this.inclusionsDialog) this.inclusionsDialog.close();
    });

    this.updateCount();
    this.updateSizeFinder('diameter');
    this.renderSizeChart();
    this.updateSummary();
  }

  handleClick(event) {
    const target = event.target.closest('button');
    if (!target) return;

    if (target.matches('[data-as-engraving-toggle]')) this.toggleEngraving();
    if (target.matches('[data-as-open-size-finder]')) this.openSizeFinder();
    if (target.matches('[data-as-close-size-finder]')) this.sizeDialog?.close();
    if (target.matches('[data-as-open-inclusions]')) this.openDialog(this.inclusionsDialog);
    if (target.matches('[data-as-close-inclusions]')) this.inclusionsDialog?.close();
    if (target.matches('[data-as-use-size]')) this.useSuggestedSize();
    if (target.matches('[data-as-size-tab]')) this.showSizeTab(target.dataset.asSizeTab);
    if (target.matches('[data-as-calibrate]')) this.toggleCalibration();
    if (target.matches('[data-as-save-calibration]')) this.saveCalibration();
    if (target.matches('[data-as-cancel-calibration]')) this.cancelCalibration();
    if (target.matches('[data-as-chart-size]')) this.selectChartSize(Number(target.dataset.asChartSize));
    if (target.matches('[data-as-engraving-style]')) this.setSegmentedValue('[data-as-engraving-style]', target, '[data-as-engraving-font-value]', target.dataset.asEngravingStyle);
    if (target.matches('[data-as-engraving-placement]')) this.setSegmentedValue('[data-as-engraving-placement]', target, '[data-as-engraving-placement-value]', target.dataset.asEngravingPlacement);
  }

  handleInput(event) {
    if (event.target.matches('[data-as-engraving-input]')) {
      this.updateCount();
      this.updateEngravingPreview();
      this.updateSummary();
    }
    if (event.target.matches('[data-as-size-range]')) this.updateSizeFinder('diameter');
    if (event.target.matches('[data-as-finger-range]')) this.updateSizeFinder('circumference');
    if (event.target.matches('[data-as-calibration-range]')) this.previewCalibration();
    if (event.target.matches('input[name="properties[Ring Size]"]')) this.updateSummary();
  }

  toggleEngraving() {
    if (!this.toggle || !this.fields) return;
    const enabled = this.toggle.getAttribute('aria-checked') !== 'true';
    this.toggle.setAttribute('aria-checked', String(enabled));
    this.fields.hidden = !enabled;
    this.querySelectorAll('[data-as-engraving-field]').forEach((field) => {
      field.disabled = !enabled;
    });
    if (enabled) window.requestAnimationFrame(() => this.engravingInput?.focus());
    this.updateSummary();
  }

  updateCount() {
    if (this.count) this.count.textContent = String(this.engravingInput?.value.length || 0);
  }

  updateEngravingPreview() {
    const preview = this.querySelector('[data-as-engraving-preview]');
    if (preview) preview.textContent = this.engravingInput?.value || preview.dataset.placeholder || 'Your words here';
  }

  setSegmentedValue(selector, target, outputSelector, value) {
    this.querySelectorAll(selector).forEach((button) => {
      const active = button === target;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const output = this.querySelector(outputSelector);
    if (output) output.value = value || '';
    if (selector.includes('style')) {
      const preview = this.querySelector('[data-as-engraving-preview]');
      if (preview) preview.dataset.font = value.toLowerCase().replaceAll(' ', '-');
    }
    this.updateSummary();
  }

  openSizeFinder() {
    this.updateSizeFinder('diameter');
    this.openDialog(this.sizeDialog);
  }

  openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  showSizeTab(tab) {
    this.querySelectorAll('[data-as-size-tab]').forEach((button) => {
      const active = button.dataset.asSizeTab === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    this.querySelectorAll('[data-as-size-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.asSizePanel !== tab;
    });
  }

  getAvailableSizes() {
    return [...this.querySelectorAll('input[name="properties[Ring Size]"]')]
      .map((input) => Number.parseFloat(input.value))
      .filter(Number.isFinite);
  }

  closestChartEntry(value, key = 'diameter') {
    return AS_RING_SIZE_CHART.reduce((best, entry) =>
      Math.abs(entry[key] - value) < Math.abs(best[key] - value) ? entry : best
    );
  }

  closestAvailableSize(size) {
    const available = this.getAvailableSizes();
    if (!available.length) return size;
    return available.reduce((best, candidate) =>
      Math.abs(candidate - size) < Math.abs(best - size) ? candidate : best
    );
  }

  updateSizeFinder(source = 'diameter') {
    const raw = source === 'circumference' ? Number.parseFloat(this.fingerRange?.value) : Number.parseFloat(this.sizeRange?.value);
    if (!Number.isFinite(raw)) return;
    const chartEntry = this.closestChartEntry(raw, source === 'circumference' ? 'circumference' : 'diameter');
    const availableSize = this.closestAvailableSize(chartEntry.us);
    const entry = AS_RING_SIZE_CHART.find((item) => item.us === availableSize) || chartEntry;
    this.suggestedSize = availableSize;

    if (source === 'diameter' && this.fingerRange) this.fingerRange.value = String(entry.circumference);
    if (source === 'circumference' && this.sizeRange) this.sizeRange.value = String(entry.diameter);

    this.querySelectorAll('[data-as-diameter]').forEach((node) => { node.textContent = entry.diameter.toFixed(1); });
    this.querySelectorAll('[data-as-circumference]').forEach((node) => { node.textContent = entry.circumference.toFixed(1); });
    this.querySelectorAll('[data-as-size-result], [data-as-use-size-label]').forEach((node) => { node.textContent = String(availableSize); });
    this.querySelectorAll('[data-as-uk-result]').forEach((node) => { node.textContent = entry.uk; });
    this.querySelectorAll('[data-as-eu-result]').forEach((node) => { node.textContent = String(entry.eu); });

    const circle = this.querySelector('[data-as-ring-circle]');
    if (circle) {
      const pixelsPerMillimeter = 96 / 25.4 * this.screenScale;
      circle.style.width = `${entry.diameter * pixelsPerMillimeter}px`;
      circle.style.height = `${entry.diameter * pixelsPerMillimeter}px`;
    }
    this.highlightChartRow(availableSize);
  }

  selectChartSize(size) {
    const entry = AS_RING_SIZE_CHART.find((item) => item.us === size);
    if (!entry) return;
    if (this.sizeRange) this.sizeRange.value = String(entry.diameter);
    this.updateSizeFinder('diameter');
  }

  renderSizeChart() {
    const chart = this.querySelector('[data-as-size-chart-body]');
    if (!chart || chart.children.length) return;
    AS_RING_SIZE_CHART.forEach((entry) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.dataset.asChartSize = String(entry.us);
      row.innerHTML = `<span>${entry.us}</span><span>${entry.uk}</span><span>${entry.eu}</span><span>${entry.diameter.toFixed(1)} mm</span><span>${entry.circumference.toFixed(1)} mm</span>`;
      chart.append(row);
    });
    this.highlightChartRow(this.suggestedSize);
  }

  highlightChartRow(size) {
    this.querySelectorAll('[data-as-chart-size]').forEach((row) => {
      row.classList.toggle('is-active', Number(row.dataset.asChartSize) === Number(size));
    });
  }

  toggleCalibration() {
    const panel = this.querySelector('[data-as-calibration-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    if (!panel.hidden && this.calibrationRange) {
      this.calibrationRange.value = String(this.screenScale);
      this.previewCalibration();
    }
  }

  previewCalibration() {
    const card = this.querySelector('[data-as-calibration-card]');
    const value = Number.parseFloat(this.calibrationRange?.value || '1');
    if (card && Number.isFinite(value)) card.style.width = `${85.6 * (96 / 25.4) * value}px`;
  }

  saveCalibration() {
    const value = Number.parseFloat(this.calibrationRange?.value || '1');
    if (!Number.isFinite(value)) return;
    this.screenScale = value;
    localStorage.setItem('as-ring-screen-scale', String(value));
    this.toggleCalibration();
    this.updateSizeFinder('diameter');
  }

  cancelCalibration() {
    const panel = this.querySelector('[data-as-calibration-panel]');
    if (panel) panel.hidden = true;
  }

  useSuggestedSize() {
    const size = this.suggestedSize ?? Number.parseFloat(this.querySelector('[data-as-size-result]')?.textContent);
    const input = [...this.querySelectorAll('input[name="properties[Ring Size]"]')]
      .find((candidate) => Number.parseFloat(candidate.value) === Number(size));
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.sizeDialog?.close();
    this.updateSummary();
  }

  updateSummary() {
    const size = this.querySelector('input[name="properties[Ring Size]"]:checked')?.value;
    const sizeOutput = this.querySelector('[data-as-summary-size]');
    if (sizeOutput) sizeOutput.textContent = size ? `Size ${size}` : 'Choose a ring size';

    const engravingOutput = this.querySelector('[data-as-summary-engraving]');
    if (!engravingOutput) return;
    const engravingEnabled = this.toggle?.getAttribute('aria-checked') === 'true';
    if (!engravingEnabled) {
      engravingOutput.hidden = true;
      engravingOutput.textContent = '';
      return;
    }
    const text = this.engravingInput?.value || 'Text to be confirmed';
    const font = this.querySelector('[data-as-engraving-style].is-active')?.dataset.asEngravingStyle || 'Script';
    const placement = this.querySelector('[data-as-engraving-placement].is-active')?.dataset.asEngravingPlacement || 'Inside band';
    engravingOutput.textContent = `Engraving: ${text} · ${font} · ${placement}`;
    engravingOutput.hidden = false;
  }
}

if (!customElements.get('as-product-personalization')) {
  customElements.define('as-product-personalization', ASProductPersonalization);
}
})();
